module.exports = __webpack_public_path__ + "img/finlandes.4b7930db.svg";